module.exports = __webpack_public_path__ + "img/SinproRO.9893b0ca.png";